import { AxiosInstance, AxiosResponse } from "axios";
import { ApiPath } from "..";
import { PriceModel, PriceParams } from "../product/product-types";
import { ApiResponse } from "../public-types";
import {
  AcknowledgeReservation,
  AvailableReservations,
  AvailableReserveTimes,
  EffectiveFacilityPolicies,
  QuotationModel,
  QuotationParams,
  QuotationRequest,
  ReservationPeriodParams,
  ReservationQueryParams,
  ReservationTimesParams,
} from "./reservation-type";
import { RvIncompleteReason } from "src/pages/contract/constants";
import { CommonFacilityType } from "../building/building-types";
import qs from "qs";

// ============== v.1.19 새로운 api 수정중 ==============

/**TES01. (무인증)예약가능구간 설정 결과 목록 조회 > [시간 슬롯에 설정]*/
export const getReserveDurationAsyc = async (
  axios: AxiosInstance,
  params?: ReservationPeriodParams,
): //
Promise<AxiosResponse<ApiResponse<{ content: AvailableReservations[] }>>> => {
  return await axios.get(`/api/court/et/public/availableReservationTime/SERVICE_PRODUCT/${params?.serviceId}`, {
    params: {
      buildingCommonFacilityId: params?.buildingCommonFacilityId,
      commonFacilityType: params?.commonFacilityType,
    },
  });
};

/**TES02. (무인증)예약시간단위 설정 결과 목록 조회 > [최소 ~ 최대 몇시간 이상]*/
export const getMinMaxReservationTimeAsyc = async (
  axios: AxiosInstance,
  params?: ReservationTimesParams,
): //
Promise<AxiosResponse<ApiResponse<{ content: AvailableReserveTimes[] }>>> => {
  return await axios.get(`/api/court/et/public/unitReservationTime/SERVICE_PRODUCT/${params?.serviceId}`, {
    params,
  });
};

/**TIP01. (무인증) 요금 조회 > v.1.19 에 그대로 사용*/
export async function getPriceAsync(
  axios: AxiosInstance,
  params?: PriceParams, //
): Promise<AxiosResponse<ApiResponse<{ content: PriceModel[] }>>> {
  return await axios.get(ApiPath.prices.list, {
    params,
  });
}

// =================================================

/**TIQ02 - (무인증)견적서 등록*/
export async function postQuotationAsync(
  axios: AxiosInstance,
  params?: QuotationRequest, //
): Promise<AxiosResponse<ApiResponse<{ content: QuotationModel }>>> {
  const data = {
    quotationItemList: params!.quotationItemList,
  };

  const headers: Record<string, string> = { "X-Recaptcha-Token": params!.token };
  // policy-based challenge 방식 사이트키를 사용하는 경우 함께 전달
  if (params?.siteKey) {
    headers["X-Recaptcha-Site-Key"] = params.siteKey;
  }

  return await axios.post(
    ApiPath.quotation.add,
    {
      quotation: data,
    },
    { headers },
  );
}

//TIQ01 - (무인증)견적서 목록(상세)
export async function getQuotationListPublicAsync(
  axios: AxiosInstance,
  params?: QuotationParams, //
): Promise<AxiosResponse<ApiResponse<{ content: QuotationModel[] }>>> {
  const headers: Record<string, string> = { "X-Recaptcha-Token": params?.token || "" };
  // policy-based challenge 방식 사이트키를 사용하는 경우 함께 전달
  if (params?.siteKey) {
    headers["X-Recaptcha-Site-Key"] = params.siteKey;
  }
  return await axios.get(ApiPath.quotation.list.public, {
    params: { quotationNo: params?.quotationNo },
    headers,
  });
}

//TIQ01 - (인증)견적서 목록(상세)
export async function getQuotationListAsync(
  axios: AxiosInstance,
  params?: QuotationParams, //
): Promise<AxiosResponse<ApiResponse<{ content: QuotationModel[] }>>> {
  return await axios.get(ApiPath.quotation.list.auth, {
    params: { quotationNo: params!.quotationNo },
  });
}

/**TRV10. (무인증) 공용 공간 예약 점유 현황 조회*/
export async function getReservedTimesAsync(
  axios: AxiosInstance,
  params?: ReservationQueryParams,
): Promise<AxiosResponse<ApiResponse<{ content: AcknowledgeReservation[] }>>> {
  return await axios.get("/api/court/rv/public/acknowledged/reservations", {
    params,
  });
}

/**TRV01. 사용자 예약 목록 페이지 조회*/
export async function getReservationsAsync(
  axios: AxiosInstance,
  params?: ReservationQueryParams,
): Promise<AxiosResponse<ApiResponse<{ content: AcknowledgeReservation[] }>>> {
  return await axios.get("/api/court/rv/my/reservations", {
    params,
  });
}

/**TRV13. 사용자 예약 취소처리*/
export async function deleteReservationAsync(
  axios: AxiosInstance,
  params?: {
    reservationId?: string;
  },
): Promise<AxiosResponse<ApiResponse<{ content: AcknowledgeReservation[] }>>> {
  if (!params?.reservationId) {
    throw Error("reservationId is not found");
  }
  return await axios.delete(`/api/court/rv/my/reservations/${params.reservationId}`);
}

/**TRVP07. (무인증) 상품 공용 공간 유효 예약 정책 목록 조회 > 예약 시작 시간 설정 / 휴무일 / 이용 한도*/
export async function getReservationPoliciesAsync(
  axios: AxiosInstance,
  params?: {
    productId: string;
    facilityIds: string[]; // 최대 10개 요청 가능
  },
): Promise<AxiosResponse<{ facilities?: EffectiveFacilityPolicies[] }>> {
  return await axios.get(`/api/court/rv/public/products/${params?.productId}/reservation-policies/effective`, {
    params: { facilityId: params?.facilityIds.join(",") },
  });
}

/**TRVP02. (무인증) 상품 공용 공간 예약 검증 시도*/
export async function postReservationDryRunAsync(
  axios: AxiosInstance,
  params?: {
    productId?: string;
    request: {
      start: string;
      end: string;
      facilityId: string;
    };
  },
): Promise<AxiosResponse<ApiResponse<{ result: { incompleteReasons: RvIncompleteReason[] } }>>> {
  if (!params?.productId) {
    throw Error("productId is not found");
  }
  return await axios.post(`/api/court/rv/public/products/${params.productId}/reservation/dry-run`, {
    ...params?.request,
  });
}
